import { useTranslation } from 'react-i18next';

import { AnimationShell, Avatar, Button, Icon, Link, Typography } from '@/components';
import { ASSETS_BASE_URL } from '@/config';

import { ServiceDetails } from '../../types';
import { useOnCreateAdvisorIntro } from '../../hooks/use-on-create-service-intro';
import { useCallback, useState } from 'react';
import { useCurrentUser } from '@/features/users/hooks';

export type ServiceContactProps = {
  readonly service: ServiceDetails;
};

export function ServiceContact({ service }: ServiceContactProps) {
  const [isRequested, setIsRequested] = useState(false);
  const { t } = useTranslation(['services']);
  const user = useCurrentUser();
  if (!user) return null;

  const { createAdvisorIntro } = useOnCreateAdvisorIntro({
    companyId: user.company.id,
    advisorId: service.id,
    advisorName: service.name
  });

  const handleRequestIntro = useCallback(() => {
    createAdvisorIntro();
    setIsRequested(true);
  }, [createAdvisorIntro]);

  return (
    <section className="space-y-8">
      <AnimationShell type="slide-left" className="space-y-4">
        <Typography as="h4" size="heading-2" color="primary" weight="semibold">
          {t('Contacts')}
        </Typography>
        {service.website && (
          <div>
            <Link to={service.website} target="_blank" className="flex items-center">
              <Icon name="web" className="mr-2 w-10" />
              {t('Website')}
            </Link>
          </div>
        )}
        {service.linkedin && (
          <div>
            <Link to={service.linkedin} target="_blank" className="flex items-center">
              <Icon name="linkedin" className="mr-2 w-10" />
              {t('Linkedin')}
            </Link>
          </div>
        )}
        {/* {service.primaryPhone && (
          <div className="flex items-center">
            <Icon name="phone" className="text-primary-700 mr-2 w-10" />
            <Typography as="p" size="body-2" color="secondary" weight="normal">
              {service.primaryPhone}
            </Typography>
          </div>
        )}
        {service.secondaryPhone && (
          <div className="flex items-center">
            <Icon name="smartphone" className="text-primary-700 mr-2 w-10" />
            <Typography as="p" size="body-2" color="secondary" weight="normal">
              {service.secondaryPhone}
            </Typography>
          </div>
        )} */}
        <Button size="md" color="primary" onClick={handleRequestIntro} disabled={isRequested}>
          {isRequested ? t('Intro requested') : t('Request an intro')}
        </Button> 
      </AnimationShell>

      {service.contacts.map((contact, index) => (
        <AnimationShell type="slide-left" className="grid grid-cols-4 items-center" key={`contact-${index}`}>
          <Avatar
            firstName={contact.firstName}
            lastName={contact.lastName}
            fullName={contact.fullName}
            avatar={contact.avatar ? `${ASSETS_BASE_URL}/${contact.avatar}` : ''}
            size="lg"
          />
          <div className="col-span-3">
            <Typography as="p" size="body-2" color="primary" weight="normal">
              {contact.fullName}
            </Typography>

            <Typography as="p" size="body-3" weight="normal" color="secondary" className="">
              {contact.position}
              {/* <span className="inline-flex items-baseline">
                {contact.email && (
                  <Link to={`mailto:${contact.email}`} className="inline-flex gap-x-1">
                    <Icon name="mail" className="h-4 w-6" />
                  </Link>
                )}
                {contact.linkedin && (
                  <Link to={contact.linkedin} target="_blank" className="inline-flex">
                    <Icon name="linkedin" className="h-4 w-4" />
                  </Link>
                )}
              </span> */}
            </Typography>
          </div>
        </AnimationShell>
      ))}
    </section>
  );
}
